'use client';

import { useEffect } from 'react';
import { useNavigate } from 'react-router';

import { ADMIN_DESTINATIONS, destinationPathFor } from './admin-destinations';
import {
  CommandDialog,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from '@/components/ui/command';

export interface AdminCommandPaletteProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

const QUICK_LINKS = [
  { label: 'Catalog → Episodes', href: '/admin/catalog' },
  { label: 'Catalog → Collections', href: '/admin/catalog?tab=collections' },
  { label: 'Publishing → Changelogs', href: '/admin/publishing' },
  { label: 'Publishing → Quotes', href: '/admin/publishing?tab=quotes' },
  { label: 'Users → Directory', href: '/admin/users' },
  { label: 'Users → Badges', href: '/admin/users?tab=badges' },
  { label: 'Appearance → Themes', href: '/admin/appearance' },
  { label: 'System → Settings', href: '/admin/system' },
  { label: 'System → OAuth Clients', href: '/admin/system?tab=oauth' },
];

export function AdminCommandPalette({
  open,
  onOpenChange,
}: AdminCommandPaletteProps): React.ReactElement {
  const navigate = useNavigate();

  // ⌘K / Ctrl+K to toggle
  useEffect(() => {
    const handler = (e: KeyboardEvent): void => {
      if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
        e.preventDefault();
        onOpenChange(!open);
      }
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [open, onOpenChange]);

  const go = (href: string): void => {
    onOpenChange(false);
    navigate(href);
  };

  return (
    <CommandDialog open={open} onOpenChange={onOpenChange}>
      <CommandInput placeholder="Search destinations and quick links…" />
      <CommandList>
        <CommandEmpty>No results.</CommandEmpty>
        <CommandGroup heading="Destinations">
          {ADMIN_DESTINATIONS.map((d) => (
            <CommandItem
              key={d.slug}
              value={d.label}
              onSelect={() => go(destinationPathFor(d.slug))}
            >
              {d.label}
            </CommandItem>
          ))}
        </CommandGroup>
        <CommandGroup heading="Quick links">
          {QUICK_LINKS.map((q) => (
            <CommandItem
              key={q.href}
              value={q.label}
              onSelect={() => go(q.href)}
            >
              {q.label}
            </CommandItem>
          ))}
        </CommandGroup>
      </CommandList>
    </CommandDialog>
  );
}
